import { Link } from "react-router";

export function NotFoundPage({ message = "The page you're looking for doesn't exist." }: { message?: string }) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 px-4 text-center">
      <div className="text-5xl font-bold text-faint">404</div>
      <p className="text-muted">{message}</p>
      <Link to="/" className="text-sm text-accent hover:underline">
        Go to your projects
      </Link>
    </div>
  );
}
